import axios from 'axios'

export default axios.create({
    baseURL: 'http://localhost:8000', //'https://www.3daigen.com/3daigenback/', //process.env.REACT_APP_BASE_URL, //'http://localhost:5000' /* https://www.palladiumtest.live/paladiumback' ||process.env.BASE_URL*/,
    headers:{'Content-Type':'application/json'}
})